export default "__VITE_ASSET__6mLGbyB9__"